import { Group } from 'types';
import { GroupStats, GroupsResponse } from 'types/groups';
import { api } from './api';

const groupsApi = api
  .enhanceEndpoints({
    addTagTypes: ['Groups'],
  })
  .injectEndpoints({
    endpoints: ($) => ({
      getAllGroups: $.query<GroupStats[], { short?: boolean } | void>({
        query: (params) => ({
          url: '/users/admin/groups',
          params,
        }),
        transformResponse: (r: GroupsResponse) => r.groups,
        providesTags: ['Groups'],
      }),
      createGroup: $.mutation<void, Group>({
        query: (group) => ({
          url: '/users/admin/groups',
          method: 'POST',
          data: group,
        }),
        invalidatesTags: ['Groups'],
      }),
      deleteGroup: $.mutation({
        query: (groupName: string) => ({
          url: `/users/admin/groups/${groupName}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Groups'],
      }),
    }),
  });

export const {
  useGetAllGroupsQuery,
  useDeleteGroupMutation,
  useCreateGroupMutation,
} = groupsApi;
